import * as authConstants from './actionTypes'
import { postLogoutRedirectUri, msalConfig } from '../../authConfig'
import { setCookie } from '../../Helpers/cookies'
import axiosClient from '../../services/axiosClient'
import config from 'config/config'
import ReactGA from 'react-ga4'
import { makeURL } from '../../components/Utils'
import { CLEAR_SESSION, CLIENT_INFO, LOGOUT } from '../../components/endpoints'
export function getClientInfo (msalIns) {
  return (dispatch) => {
    dispatch({
      type: authConstants.AZURE_LOGIN
    })

    axiosClient.defaults.baseURL = makeURL(config.API_VERSION)
    axiosClient.defaults.headers.Authorization = window.sessionStorage.getItem('id_token')
    axiosClient.get(CLIENT_INFO)
      .then((response) => {
        ReactGA.event({
          category: 'API',
          action: 'Client Info',
          label: 'Success'
        })
        if (response.data.isOptumUser) {
          ReactGA.event({
            category: 'Client Type',
            action: 'Optum User'
            // label: response.data.isOptumUser ? 'Yes' : 'No'
          })
        } else {
          ReactGA.event({
            category: 'Client Type',
            action: 'Azure User'
            // label: response.data.isOptumUser ? 'Yes' : 'No'
          })
        }
        dispatch({
          type: authConstants.AZURE_LOGIN_SUCCESS,
          payload: response.data
        })
      }).catch((error) => {
        ReactGA.event({
          category: 'API',
          action: 'Client Info',
          label: 'Failure'
        })
        const currentAccount = msalIns.getAccountByHomeId(JSON.parse(window.sessionStorage.getItem('home_account')).homeAccountId)
        if (error.response.data.code === 'USRLKD') {
          msalIns.logout({
            account: currentAccount,
            postLogoutRedirectUri: postLogoutRedirectUri.redirectUri,
            authority: msalConfig.auth.authority,
            lockAccount: true
          })
        } else if (error.response.data.code === 'UNAUTH') {
          msalIns.logout({
            account: currentAccount,
            postLogoutRedirectUri: postLogoutRedirectUri.redirectUri,
            authority: msalConfig.auth.authority,
            isUnAuthorizedMALogin: true
          })
        } else if (error.response.data.code === 'INVSUP') {
          msalIns.logout({
            account: currentAccount,
            postLogoutRedirectUri: postLogoutRedirectUri.redirectUri,
            authority: msalConfig.auth.authority,
            isInvalidSuperUserLogin: true
          })
        } else {
          msalIns.logout({
            account: currentAccount,
            postLogoutRedirectUri: postLogoutRedirectUri.redirectUri,
            authority: msalConfig.auth.authority
          })
        }
        setCookie('isLoginFailed', true)
        window.sessionStorage.clear()
        dispatch({
          type: authConstants.AZURE_LOGIN_FAILURE,
          payload: error
        })
      })
  }
}

export function azureLogOut (msalInstance) {
  window.sessionStorage.setItem('is_Logout', true)
  if (window.sessionStorage.getItem('home_account')) {
    const currentAccount = msalInstance.getAccountByHomeId(JSON.parse(window.sessionStorage.getItem('home_account')).homeAccountId)
    msalInstance.logoutRedirect({
      account: currentAccount,
      postLogoutRedirectUri: postLogoutRedirectUri.redirectUri,
      authority: msalConfig.auth.authority
    })
  } else {
    msalInstance.logoutRedirect({
      postLogoutRedirectUri: postLogoutRedirectUri.redirectUri,
      authority: msalConfig.auth.authority
    })
  }
  return (dispatch) => {
    dispatch({
      type: authConstants.AZURE_LOGOUT
    })
    axiosClient.defaults.baseURL = makeURL(config.API_VERSION)
    axiosClient.defaults.headers.Authorization = window.sessionStorage.getItem('id_token')
    axiosClient.get(LOGOUT)
      .then((response) => {
        ReactGA.event({
          category: 'API',
          action: 'Logout',
          label: 'Success'
        })
        dispatch({
          type: authConstants.AZURE_LOGOUT_SUCCESS
        })
      }).catch(() => {
        ReactGA.event({
          category: 'API',
          action: 'Logout',
          label: 'Failure'
        })
        dispatch({
          type: authConstants.AZURE_LOGOUT_FAILURE
        })
      })
  }
}

export function clearSession () {
  return (dispatch) => {
    dispatch({
      type: authConstants.CLEAR_SESSION
    })
    axiosClient.defaults.baseURL = makeURL(config.API_VERSION)
    axiosClient.defaults.headers.Authorization = window.sessionStorage.getItem('id_token')
    axiosClient.get(CLEAR_SESSION)
      .then((response) => {
        ReactGA.event({
          category: 'API',
          action: 'ClearSession',
          label: 'Success'
        })
        dispatch({
          type: authConstants.CLEAR_SESSION_SUCCESS
        })
      }).catch(() => {
        ReactGA.event({
          category: 'API',
          action: 'ClearSession',
          label: 'Failure'
        })
        dispatch({
          type: authConstants.CLEAR_SESSION_FAILURE
        })
      })
  }
}
